import Button from '@components/buttons';
import EmptyResults from '@components/EmptyResults';
import { Box, Flex } from '@components/layout/Grid';
import { Trans } from '@lingui/react';

const EmptyResultsGenre = props => {
  return (
    <EmptyResults
      data-testid="EmptyResultsGenre"
      title={
        <>
          <Trans
            id="videos_genres.count"
            message={'{count} hits'}
            values={{ count: 0 }}
          />{' '}
          {props.keyword && (
            <Trans
              id="videos_genres.keyword"
              message={'for keyword "{keyword}"'}
              values={{ keyword: props.keyword }}
            />
          )}
        </>
      }
      icon="ygb-icon-searchb"
      action={
        <>
          {!props.emptyTerms ? (
            <>
              <Trans
                id="emptyresults.try_adjusting_or"
                message={`Try adjusting your search criteria for more results, or`}
              />{' '}
              <Button appearance="link" onClick={props.clearAll}>
                <Trans id="emptyresults.click_here" message={`click here`} />
              </Button>{' '}
              <Trans
                id="emptyresults.to_clear_filters"
                message={`to clear all filters`}
              />
            </>
          ) : (
            <>
              <Flex
                flexDirection="column"
                alignItems="center"
                px={['10px', '10px', '200px']}
              >
                <Box mb="30px">
                  <Trans
                    id="emptyresults.empty_filter"
                    message={`Please adjust your tags above and edit your video <0>settings</0> like languages, level, etc... to get the results you are looking for`}
                    components={[
                      <Button
                        key="settings"
                        appearance="link"
                        onClick={props.openSettingModal}
                      />,
                    ]}
                  />
                </Box>
              </Flex>
            </>
          )}
        </>
      }
    />
  );
};

export default EmptyResultsGenre;
